<template>
	<nut-dialog
		teleport="body"
		title="修改密码"
		:visible="modelValue"
		@ok="hanldleOK"
		@cancel="hanldleClose"
	>
		<form>
			<nut-input
				class="input"
				placeholder="请输入旧密码"
				v-model="pwds.password"
				type="password"
			/>
			<nut-input
				class="input"
				placeholder="请输入新密码"
				v-model="pwds.newPassword"
				type="password"
			/>
			<nut-input
				class="input"
				placeholder="请再次输入新密码"
				v-model="pwds.repeatNewPassword"
				type="password"
			/>
		</form>
	</nut-dialog>
</template>

<script>
import { Toast } from '@nutui/nutui';
import { reactive } from 'vue';
import { useStore } from 'vuex';
import { passwordValidReg } from '@/utils/util.regexp';
import MD5 from 'crypto-js/md5';
import { userApi } from '@/apis';

export default {
	name: 'EditPasswordModal',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const store = useStore();
		const pwds = reactive({
			password: '',
			newPassword: '',
			repeatNewPassword: '',
		});
		const hanldleClose = () => {
			pwds.password = pwds.newPassword = pwds.repeatNewPassword = '';
			emit('update:modelValue', false);
		};
		const toast = (msg, type = 'warn', options = {}) => {
			Toast[type](msg, {
				duration: 1000,
				...options,
			});
		};
		const hanldleOK = async () => {
			if (!pwds.password) return toast('请输入旧密码');
			if (!pwds.newPassword) return toast('请输入新密码');
			if (!pwds.repeatNewPassword) return toast('请再次输入新密码');
			if (pwds.repeatNewPassword !== pwds.newPassword)
				return toast('两次新密码不一致');
			if (!passwordValidReg.test(pwds.newPassword))
				return toast('密码须包含数组和字母，长度不少于6位');
			await userApi.user_edit_password({
				password: MD5(pwds.password).toString(),
				newpassword: MD5(pwds.newPassword).toString(),
			});
			toast('修改成功', 'success', {
				onClose() {
					hanldleClose();
					store.dispatch('user/logout');
				},
			});
		};
		return {
			pwds,
			hanldleClose,
			hanldleOK,
		};
	},
};
</script>

<style lang="scss" scoped>
.input {
	padding: 6px 0;
	font-size: $small-font-size;
}
</style>
